import SiteConfig from './SiteConfig'
const Systems = SiteConfig.System
export default Systems
